(() => {
  const sliders = new Map();

  const getNumber = (value, fallback) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  };

  const mountSlider = (container) => {
    if (!window.Splide || sliders.has(container) || container.dataset.layout !== 'carousel') return;

    const sliderElement = container.querySelector('.splide');
    if (!sliderElement) return;

    const slideCount = sliderElement.querySelectorAll('.splide__slide').length;
    const mobileColumns = getNumber(container.dataset.mobileColumns, 2);
    const desktopColumns = getNumber(container.dataset.desktopColumns, 4);
    const slideSpeed = getNumber(container.dataset.slideSpeed, 1200);
    const gap = 0;

    const canDrag = slideCount > mobileColumns;
    const splide = new Splide(sliderElement, {
      type: 'slide',
      rewind: false,
      perPage: desktopColumns,
      perMove: desktopColumns,
      gap,
      arrows: canDrag,
      pagination: canDrag,
      speed: slideSpeed,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      drag: canDrag,
      flickPower: 300,
      flickMaxPages: 1,
      waitForTransition: true,
      keyboard: 'focused',
      breakpoints: {
        980: {
          perPage: mobileColumns,
          perMove: mobileColumns,
          gap,
        },
      },
    });

    window.decorateSplide?.(splide, container);
    splide.mount();
    window.updateSplideArrows?.(container);

    if (canDrag) {
      bindTrackpadScroll(sliderElement, splide, slideSpeed);
    }

    sliders.set(container, splide);
  };

  const bindTrackpadScroll = (sliderElement, splide, slideSpeed = 1200) => {
    if (sliderElement.dataset.trackpadBound === 'true') return;
    sliderElement.dataset.trackpadBound = 'true';

    let locked = false;
    let unlockTimer = null;

    const onWheel = (event) => {
      const absX = Math.abs(event.deltaX);
      const absY = Math.abs(event.deltaY);
      if (absX < 10 || absX <= absY) return;

      event.preventDefault();
      if (locked || splide.state.is(window.Splide.STATES?.MOVING)) return;

      locked = true;
      splide.go(event.deltaX > 0 ? '>' : '<');

      window.clearTimeout(unlockTimer);
      unlockTimer = window.setTimeout(() => {
        locked = false;
      }, Math.max(slideSpeed, 420));
    };

    sliderElement.addEventListener('wheel', onWheel, { passive: false });
    sliderElement._featuredCollectionWheel = onWheel;
  };

  const mountAll = (scope = document) => {
    scope.querySelectorAll('[data-featured-collection]').forEach(mountSlider);
  };

  const destroySlider = (container) => {
    const splide = sliders.get(container);
    if (!splide) return;

    const sliderElement = container.querySelector('.splide');
    if (sliderElement?._featuredCollectionWheel) {
      sliderElement.removeEventListener('wheel', sliderElement._featuredCollectionWheel);
      delete sliderElement._featuredCollectionWheel;
      delete sliderElement.dataset.trackpadBound;
    }

    splide.destroy(true);
    sliders.delete(container);
  };

  document.addEventListener('DOMContentLoaded', () => mountAll());

  document.addEventListener('shopify:section:load', (event) => {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-featured-collection]').forEach(destroySlider);
  });
})();
